import styled from 'styled-components';
import { UIElements } from '@ansvar-sakerhet/ui';
import * as Dialog from '@radix-ui/react-dialog';

const Overlay = styled(Dialog.Overlay)`
  background-color: rgba(0, 0, 0, 0.25);
  position: fixed;
  z-index: 200;
  inset: 0;
  display: grid;
  place-items: center;
  overflow-y: auto;
`;

const Content = styled(Dialog.Content)`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 16px;
  margin: 48px 0;
  width: min(520px, 92vw);
  padding: 32px 40px;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.15);
`;

const ContentHeader = styled.div`
  margin-bottom: 24px;
`;

const StepList = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const StepItem = styled.li<{ $status: 'pending' | 'active' | 'complete' | 'failed' }>`
  display: flex;
  align-items: center;
  gap: 12px;
  color: ${({ $status }) => {
    if ($status === 'pending') return '#999';
    if ($status === 'failed') return '#c0392b';
    return '#111';
  }};
  font-weight: ${({ $status }) => ($status === 'active' ? 600 : 400)};
`;

const StepIndicator = styled.span<{ $status: 'pending' | 'active' | 'complete' | 'failed' }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  font-size: 12px;
  border: 2px solid
    ${({ $status, theme }) => {
      if ($status === 'complete') return theme.colors.primary;
      if ($status === 'active') return theme.colors.primary;
      if ($status === 'failed') return '#c0392b';
      return '#cbcbcb';
    }};
  background-color: ${({ $status, theme }) => {
    if ($status === 'complete') return theme.colors.primary;
    if ($status === 'failed') return '#c0392b';
    return 'transparent';
  }};
  color: ${({ $status }) =>
    $status === 'complete' || $status === 'failed' ? '#fff' : 'inherit'};
`;

const SuccessMessage = styled(UIElements.B2)`
  margin: 24px 0 0;
  color: #1e7e34;
`;

const ErrorMessage = styled(UIElements.B2)`
  margin: 24px 0 0;
  color: #c0392b;
`;

const ContentFooter = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 32px;
`;

export const S = {
  ...UIElements,
  Overlay,
  Content,
  ContentHeader,
  StepList,
  StepItem,
  StepIndicator,
  SuccessMessage,
  ErrorMessage,
  ContentFooter,
};
